export const onlyForDev = process.env.REACT_APP_ENV === 'local' || process.env.REACT_APP_ENV === 'development'
export const onlyForLocal = process.env.REACT_APP_ENV === 'local'
export const onlyForProd = process.env.REACT_APP_ENV === 'production'
